<template>

  <v-app :style="appBg">
    <!-- <ErrorPipelinePopup></ErrorPipelinePopup> -->
    <LegalDialog 
      v-if="showLegalDialog"
      title="Condiciones de venta" 
      v-model="sellTermsDialog"
    >
      <SaleTerms/>
    </LegalDialog> 
    <!-- <Keypress :key-code="13" event="keydown" @pressed="enter" /> -->
    <!--
    <Keypress :key-code="37" event="keydown" @pressed="previousLabel" />
    <Keypress :key-code="39" event="keydown" @pressed="nextLabel" />
    <Keypress :key-code="13" event="keydown" @pressed="enter" />
    <Keypress :key-code="46" event="keydown" @pressed="deleteLabel({ label: selectedLabel })" />
    <Keypress :key-code="key" event="keydown" @pressed="end" />-->
    <v-app-bar app class="appBar" height="75" dark clipped-left clipped-right v-if="showAppBar">
      <!-- <v-app-bar-nav-icon @click="drawer = !drawer" v-if="this.$router.currentRoute.name != 'login'" class="white--text"></v-app-bar-nav-icon> -->
      <v-app-bar-nav-icon v-once @click="drawer = !drawer" v-if="showBurger" class="white--text"></v-app-bar-nav-icon>
      <template v-if='userData' >
        <!-- <v-img v-if="domain.includes('docuxtract.docunecta.com')" :transition="false" :src="'/docunecta_logo.png'" contain :max-width="imgWidth" class="dragBar white__brand__logo" :class="{'mr-3': is_mobile}"></v-img>
        <v-img v-else-if="domain.includes('gscan.glasof.com')" :transition="false" :src="'/gscan_logo.png'" contain :max-width="imgWidth" class="dragBar white__brand__logo" :class="{'mr-3': is_mobile}"></v-img>
        <v-img v-else-if='userData.logo' :transition="false" :src="userData.logo" contain :max-width="imgWidth" class="dragBar white__brand__logo" :class="{'mr-3': is_mobile}"></v-img> -->
        <v-img v-if="appCustomLogo" :transition="false" :src="appCustomLogo" contain :max-width="imgWidth" class="dragBar white__brand__logo" :class="{'mr-3': is_mobile}"></v-img>
        <v-img v-else :transition="false" :src="imgSrc" contain :max-width="imgWidth" class="dragBar ml-2" :class="{'mr-3': is_mobile}"></v-img>
      </template>
      <v-spacer></v-spacer>
      <SelectorEmpresa
        name="SelectorEmpresa"
        v-if="showCDBSelector"
        :value="currentCompany"
        :items="get_companydbs"
        @gotInput="updateCurrentCompany"
        @changed="set_suppliers"
        :readonly="isReadonlyCDBSelector"
      ></SelectorEmpresa>
      <v-btn
        v-if="permission && (permission.general.can_admin || permission.is_employee) && showCDBSelector && !is_mobile"
        icon
        color="white"
        dark
        v-on:click="openEditCompanyDB"
      >
        <v-img class="img-top-navigation" src="/navigation/edit_square.svg" v-once>          
        </v-img>
      </v-btn>
      <v-tooltip bottom v-if="got_feature('feature_sync_thirds_invoice_list') && permission && (permission.general.can_admin || permission.is_employee) && showCDBSelector && !is_mobile && currentCompany.id && refreshAccountsState != 'pending'">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              icon
              color="white"
              dark
              v-bind="attrs" 
              v-on="on"
              @click="refresh_accounts()"
          >
            <v-icon v-once>
              mdi-account-convert
            </v-icon>
          </v-btn>
        </template>
        <span>Actualizar Proveedores y Clientes de la Empresa</span>
      </v-tooltip>
      <div v-if="got_feature('feature_sync_thirds_invoice_list') && permission && (permission.general.can_admin || permission.is_employee) && showCDBSelector && !is_mobile && refreshAccountsState === 'pending'" class="d-flex justify-center">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <v-tooltip bottom v-if="showForceDownloadLoadPathFiles">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              icon
              color="white"
              v-bind="attrs" 
              v-on="on"
              @click="forceDownloadLoadPath()"
              :loading="forceDownloadLoading"
          >
          <v-icon class="material-symbols-outlined">cloud_download</v-icon>
          </v-btn>
        </template>
        <span>Forzar descarga de los puntos de carga</span>
      </v-tooltip>
<!--       <v-progress-circular v-if="fetching_companydbs && $route.name!='login'" -->
      <v-progress-circular v-if="fetching_companydbs && showBtnGeneric"
        indeterminate
        color="secundary">
      </v-progress-circular>
      
      <v-spacer></v-spacer>
      <span v-if="this.currentCompany && this.currentCompany.available_features && (this.currentCompany.available_features.feature_kit_digital || this.currentCompany.available_features.feature_kit_digital_2)">{{ userData.business_name }}</span>
      <span style="display: contents;" v-if="this.currentCompany && this.currentCompany.available_features && !this.currentCompany.available_features.feature_kit_digital && !this.currentCompany.available_features.feature_kit_digital_2">
        <v-btn
          v-if="userData.is_staff && !is_mobile"
          v-on:click="change_debugger_mode"
          color="primary"
          elevation="0"
          
          style="background-color : transparent !important"
        >
          <div>
            <v-switch class="pt-6"
              v-model="user_data_can_debug_documents"
              :label="`DBM: ${user_data_can_debug_documents?'Sí':'No'}`"
            ></v-switch> 
          </div> 
        </v-btn> 
        <v-btn
          v-if="userData.is_staff && !is_mobile"
          v-on:click="change_trainer_mode"
          color="primary"
          elevation="0"
          style="background-color : transparent !important"
        >
          <div>
            <v-switch class="pt-6"
              v-model="user_data_can_see_training_documents"
              :label="`TM: ${user_data_can_see_training_documents?'Sí':'No'}`"
            ></v-switch> 
          </div> 
        </v-btn> 
        <div v-if="isLoginas && userData.user_role.name!='Propietario'">{{ userData.user_role.name }}</div>
        <v-btn
          v-if="isLoginas"
          :color="get_color_loginas()"
          v-on:click="unset_loginas"
          class="black--text btn_without_caps"
          rounded
        >
          {{userData.username}}
        </v-btn>
        &nbsp;&nbsp;

        <v-tooltip bottom v-if="isLoginas">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                    <v-img class="img-top-navigation" src="/navigation/location_home.svg"></v-img>
                </v-btn>
            </template>
            <span>{{userData.user_role.name}}</span>
        </v-tooltip>

        <v-btn
          v-if="userData.is_staff || isLoginas"
          icon
          color="white"
          dark
          :href="$router.resolve({name: 'debug'}).href"
        >
          <v-img class="img-top-navigation" src="/navigation/circle_settings.svg" v-once>            
          </v-img>  
        </v-btn> 
        <v-btn
          v-if="this.userData.available_features.feature_user_notifications && notifications.length"
          icon
          color="#FFED00"
          dark
          v-on:click="show_notifications_modal = true"
        >
          <v-img class="img-top-navigation" src="/navigation/notifications.svg" v-once>
          </v-img>  
        </v-btn> 
        <v-btn
          v-if="(this.userData.available_features.feature_bank_contract_finished || this.userData.available_features.feature_defaulter_user || this.userData.available_features.feature_show_triangle_contracts) && this.userData.available_features.feature_payment_on_inmatic && !this.userData.sender_docs_user_distributor_code"
          icon
          color="#FF3333"
          dark
          v-on:click="openContractModal({'msg': 'Tu contrato ha expirado o ha excedido el número máximo de documentos.', 'distributor': false, 'facturae_client': false})"
        >
          <v-icon v-once>
            mdi-alert
          </v-icon>  
        </v-btn> 
        <v-btn
          v-if="this.userData.available_features.feature_can_buy_facturae && this.userData.available_features.feature_payment_on_inmatic && !this.userData.sender_docs_user_distributor_code"
          icon
          color="#FF3333"
          dark
          v-on:click="openContractModal({'msg': 'Tu contrato de Facturas Electrónicas ha expirado o esta a punto de expirar.', 'distributor': false, 'facturae_client': false})"
        >
          <v-icon v-once>
            mdi-alert
          </v-icon>  
        </v-btn>
        <v-btn
          v-if="(this.userData.available_features.feature_bank_contract_is_going_to_finish ||this.userData.available_features.feature_contract_is_going_to_finish) && this.userData.available_features.feature_payment_on_inmatic && !this.userData.sender_docs_user_distributor_code"
          icon
          color="#FF3333"
          dark
          v-on:click="openContractModal({'msg': 'Tu contrato está a punto de expirar o de exceder el número máximo de documentos.', 'distributor': false, 'facturae_client': false})" 
        ><!-- TODO: REVISAR MENSAJE -->
          <v-icon v-once>
            mdi-alert
          </v-icon>  
        </v-btn> 
        <v-btn
          v-if="(this.userData.available_features.feature_bank_trial_contract_is_finished || this.userData.available_features.feature_trial_contract_is_finished) && this.userData.available_features.feature_payment_on_inmatic && !this.userData.sender_docs_user_distributor_code"
          icon
          color="#FF3333"
          dark          
          v-on:click="openContractModal({'msg': 'Tu contrato es de prueba, cuando expire el periodo de prueba o se excedan el número de documentos de prueba necesitarás contratar un plan.', 'distributor': false, 'facturae_client': false})"
        ><!-- TODO: REVISAR MENSAJE -->
          <v-icon v-once>
            mdi-alert
          </v-icon>  
        </v-btn>
        <v-btn
          v-if="this.userData.available_features.feature_accounting_stopped"
          icon
          color="#FFED00"
          dark
          v-on:click="show_accounting_critical_error_msg = true"
        >
          <v-icon v-once>
            mdi-alert
          </v-icon>  
        </v-btn> 

        <div v-if="!is_mobile">
          {{ session_information.username }}
        </div>
      </span>
      <v-menu
        v-if="showBtnGeneric"
        v-model="menu"
        :close-on-click="true"
        :close-on-content-click="false"
        offsetY
        class="menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            color="white"
            dark
            v-bind="attrs"
            v-on="on"
          >
            <v-icon v-once>
              mdi-account-circle-outline
            </v-icon>
            
          </v-btn>
        </template>

        <v-list id="account-menu">
          <v-list-item-group color="primary">
            <div v-for="(item, index) in user_items" :key="index">
              <v-list-group
                v-if="item.items"
                :value="false"
                no-action
                class="list-title"
                :class="{highlighted: item.highlighted, list: true}"
              >
                <template v-slot:activator>
                  <v-list-item-title class="list-title">{{ item.title }}</v-list-item-title>
                </template>
                <div v-for="(subitem, i) in item.items" :key="i">
                  <v-list-item
                    v-if="subitem.href"
                    :href="subitem.href"
                    :download="subitem.filename"
                    :class="{highlighted: subitem.highlighted, list: true}"
                    @click="menu=false"
                  >
                    <v-list-item-title class="list-title pl-4">{{ subitem.title }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-else
                    @click="subitem['click']()"
                    :class="{highlighted: subitem.highlighted, list: true}"
                  >
                    <v-list-item-title class="list-title pl-4">{{ subitem.title }}</v-list-item-title>
                  </v-list-item>
                </div>
              </v-list-group>
              <v-list-item
                v-else   
                @click="item['click']()"
                :class="{highlighted: item.highlighted, list: true}"
              >
              <!-- class="list" -->
                <v-list-item-title class="list-title">{{ item.title }} <v-icon v-if="item.icon">{{item.icon}}</v-icon></v-list-item-title>
              </v-list-item>
            </div>
          </v-list-item-group>

        </v-list>
      </v-menu>
      <v-btn
          v-if="isElectron"
          icon
          dark
          v-on:click="electronReload()"
        >
          <v-icon v-once>
            mdi-reload
          </v-icon>  
        </v-btn>
        <v-btn
        v-if="got_feature('interactive_connector')&&isElectron && !interactiveConectorStarted"
        icon
        dark
        v-on:click="electronStartInteractiveConnector()"
      >
        <v-icon v-once>
          mdi-play
        </v-icon>  
      </v-btn>
      <v-btn
        v-if="got_feature('interactive_connector')&&isElectron && interactiveConectorStarted"
        icon
        dark
        v-on:click="electronStopInteractiveConnector()"
      >
        <v-icon v-once>
          mdi-stop
        </v-icon>  
      </v-btn>
      <v-btn
        v-if="isElectron"
        icon
        dark
        v-on:click="electronMinimize()"
      >
        <v-icon v-once>
          mdi-window-minimize
        </v-icon>  
      </v-btn> 
      <v-btn
        v-if="isElectron && maximized"
        icon
        dark
        v-on:click="electronRestore()"
      >
        <v-icon v-once>
          mdi-window-restore
        </v-icon>  
      </v-btn>   
      <v-btn
        v-if="isElectron && !maximized"
        icon
        dark
        v-on:click="electronMaximize()"
      >
        <v-icon v-once>
          mdi-window-maximize
        </v-icon>  
      </v-btn>  
      <v-btn
        v-if="isElectron"
        icon
        dark
        v-on:click="electronClose()"
      >
        <v-icon v-once>
          mdi-window-close
        </v-icon>  
      </v-btn> 
    </v-app-bar>
    <v-navigation-drawer 
      app 
      clipped 
      v-if="showLeftDrawer"
      v-model="drawer" 
      class="drawer main-left-drawer py-4"
      :mini-variant="isMini"
      mini-variant-width="90"
      :width="isMini ? '90' : '256'"
      :mobile-breakpoint="960" 
    >
      <template v-for="(zone,ind) in zones">
        <template v-if="ind<2 || (permission.can_write)">
          <v-list dense nav v-bind:key="zone.heading+'3'" class="ma-0 pa-0">
            <v-list-item-group class="ma-0 pa-0">
              <template v-for="(item, i) in zone.items">
                <sidebar-element v-if="item.shouldShow" :to="item.link" :key="i" :new_label="item.new_label" :icon_type="item.img? 'image' : 'icon'" :icon_src="item.img ? item.img : item.icon">                  
                  <template #text>
                    {{item.text}}
                  </template>
                </sidebar-element>
              </template>
            </v-list-item-group>
          </v-list>
        </template>
      </template>
    </v-navigation-drawer>

    <!-- Right drawer -->
    <v-navigation-drawer
      app right 
      v-if="showRightBar && permission.can_write"
      v-model="drawer" 
      :width="got_feature('feature_new_invoice_page') ? '658' : '450'"
      clipped
      class="drawer"
      :class="got_feature('feature_new_invoice_page') ? 'transparent' : ''"
      mobile-breakpoint="0"
      
    >
      <!-- TODO: Check TrainerMode or ClientMode -->
      <RightDrawerTrainerMode v-if="documentIsDebuggerMode"></RightDrawerTrainerMode>
      <RightDrawerClientModeV2 v-else-if="got_feature('feature_new_invoice_page')"></RightDrawerClientModeV2>
      <RightDrawerClientMode v-else ></RightDrawerClientMode>
      <account-move-v2 v-if="got_feature('feature_new_invoice_page') && permission.can_write &&  showRightBar && currentDoc && currentDoc.companydb_info.companydb_type.type == 'account_move'" :key="currentDoc.id"></account-move-v2>
    </v-navigation-drawer>

    

    <v-main>
      <router-view></router-view>
    </v-main>
    <!-- TODO: El tutorial es mejor que tenga el v-if=false hasta que este en uso -->
    <Tutorial v-if="false" />
    <invoice-lines v-if="false && got_feature('feature_invoice_lines') && permission.can_write &&  showRightBar && currentDoc && currentDoc.static_invoice" :key="'invoice_lines_'+currentDoc.id.toString()"/>
    <account-move v-if="!got_feature('feature_new_invoice_page') && permission.can_write &&  showRightBar && currentDoc && currentDoc.companydb_info.companydb_type.type == 'account_move'" :key="currentDoc.id"/>

    <contract-popup v-if="showContractModal"></contract-popup>
    <v-dialog v-model="show_notifications_modal" max-width="800" >
      <Notifications></Notifications>
    </v-dialog>
    <app-confirm-modal
          v-model="show_payment_error"
          :persistent="persistent_payment_error"
          :text-msg="text_payment_error"
          :text-center-msg="text_center_payment_error"
          :title-icon="icon_payment_error"
          :show-title="show_title_payment_error"
          :text-title="text_title_payment_error"
          :show-text-question="show_question_payment_error"
          :show-confirm-button="show_confirm_button_payment_error"
          :text-confirm-button="text_confirm_button_payment_error"
          @confirm="closePaymentErrorModal()"
          :show-cancel-button="show_cancel_button_payment_error"
          @cancel="closePaymentErrorModal()"></app-confirm-modal>
    <app-confirm-modal
            v-model="show_payment_ok"
            :persistent="persistent_payment_ok"
            :text-msg="text_payment_ok"
            :text-center-msg="text_center_payment_ok"
            :title-icon="icon_payment_ok"
            :show-title="show_title_payment_ok"
            :text-title="text_title_payment_ok"
            :show-text-question="show_question_payment_ok"
            :show-confirm-button="show_confirm_button_payment_ok"
            :text-confirm-button="text_confirm_button_payment_ok"
            @confirm="closePaymentOkModal()"
            :show-cancel-button="show_cancel_button_payment_ok"
            @cancel="closePaymentOkModal()"></app-confirm-modal>
  
    <app-confirm-modal 
      v-model="showMessageModal"
      :text-msg="textMessageModal"
      :text-center-msg="textCenterMessageModal"
      :title-icon="iconMessageModal"
      :show-title="showTitleMessageModal"
      :text-title="textTitleMessageModal"
      :text-confirm-button="textConfirmButtonMessageModal"
      :show-confirm-button="showConfirmButtonMessageModal"
      :show-cancel-button="showCancelButtonMessageModal"
      :text-cancel-button="textCancelButtonMessageModal"
      :show-text-question="showQuestionMessageModal"
      :text-question="textQuestionMessageModal"  
      :persistent="persistentMessageModal"
      :is-html="htmlMessageModal"
      @cancel="actionCancelButtonMessageModal"
      @confirm="actionConfirmButtonMessageModal"
    />
    <message-popup 
      v-if="show_accounting_critical_error_msg && userData.available_features.feature_accounting_stopped"
      title="Aviso" 
      message="Se ha detenido la contabilización debido a que hemos detectado un error crítico al contabilizar una factura. Por favor revise en su programa contable si se han traspasado los datos de la factura que está en estado de error crítico."
      :actions="[{ 'action_text': 'Cancelar', 'emit': 'close-message' }, { 'action_text': 'Reanudar Contabilización', 'emit': 'start-accounting', 'prin': true }]" 
      :show_message="show_accounting_critical_error_msg" 
      @close-message="show_accounting_critical_error_msg = false"
      @start-accounting="startAccounting"
    ></message-popup>

 
    <message-popup 
      v-if="oauth_url"
      :message="oauth_msg" 
      :show_message="Boolean(oauth_url)" 
      :actions="[{ 'action_text': 'No', 'emit': 'close-message' }, { 'action_text': 'Si', 'emit': 'connect-user', 'prin': true }]"
      @connect-user="connectOauthUser"
      @close-message="closeSessionDialog"
    ></message-popup>

    <v-snackbar
       v-model="snackbar.isVisible"
       :color="snackbar.color"
   >
       <b>{{ snackbar.text }}</b>
   </v-snackbar>

  </v-app>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex"
import {client, async_command_dispatcher} from "@/api/client";
import ErrorPipelinePopup from './components/ErrorPipelinePopup.vue';
import MessagePopup from './components/MessagePopup.vue';
import SelectorEmpresa from './components/SelectorEmpresa.vue';

import RightDrawerTrainerMode from "./components/RightDrawerTrainerMode.vue";
import RightDrawerClientMode from "./components/RightDrawerClientMode.vue";
import RightDrawerClientModeV2 from "./components/RightDrawerClientModeV2.vue";
import DocTextField from "./components/DocTextField"
import AccountMove from "./components/AccountMove"
import AccountMoveV2 from "./components/AccountMoveV2"
import InvoiceLines from "./components/InvoiceLines"
import Tutorial from "./components/Tutorial"
import LegalDialog from "./components/LegalDocuments/LegalDialog.vue";
import SaleTerms from "./components/LegalDocuments/SaleTerms.vue";
import SidebarElement from '@/components/layout/SidebarElement.vue';

import { mapFields } from 'vuex-map-fields';
import { vuexPrefix } from "./store/vuex_utils";
import ContratoTratamientoDatos from "./components/WelcomeSteps/ContratoTratamientoDatos.vue";
import AppConfirmModal from './components/layout/AppConfirmModal.vue';
import ContractPopup from '@/components/ContractPopup.vue'
import Notifications from '@/components/Notifications.vue'
import { createApiTokenRepository } from '@/modules/tokens/infrastructure/ApiTokenRepository';
import { getOrCreateToken } from '@/modules/tokens/application/getOrCreateToken';
import { MultipleForceDownloadLoadPathFilesCommand } from "@/modules/load_path/app/MultipleForceDownloadLoadPathFiles"

export default {
  name: "App",
  components:{
    ErrorPipelinePopup,
    MessagePopup,
    RightDrawerTrainerMode,
    RightDrawerClientMode,
    RightDrawerClientModeV2,
    DocTextField,
    AccountMove,
    AccountMoveV2,
    InvoiceLines,
    Tutorial,
    LegalDialog,
    SaleTerms,
    SidebarElement,
    ContratoTratamientoDatos,
    SelectorEmpresa,
    AppConfirmModal, 
    ContractPopup,
    Notifications,
  },
  data() {
    return {
      error_move: 'white',
      drawer: true,
      companies: [],
      suppliers: [],
      customers: [],
      company: {},

      log_views_old: ['login'],
      log_views: ['signup', 'signup-2', 'password-reset', 'password-reset-key', 'confirm-email', 'install-schedule','white_brand', 'invoice-to-print', 'report-invoice'],
      welcome_views: ['welcome'],
      payment_views: ['create-contract', 'select-upgrade-create', 'upgrade-contract', 'create-upgrate-contract', 'payment-error', 'payment-ok'],
      update_views: ['update', 'performing-update', 'performing-updates'],
      settings_views: ['network-drives', 'settings'],
      no_cdb_selector_views: ['change_password','connectors','connector-update','connector-create','dashboard','locations','reports'],
      readonly_cdb_selector_views: ['supplier-update', 'customer-update', 'document-detail', 'other-doc-detail'],
      access_registers: ['access-registers'],
      users_permissions: ['users-permissions'],
      user_configuration: ['user-configuration'],
      bank_redirect_views: ['bank-creation', 'bank-redirect'],

      show_notifications_modal:false,
      domain: window.location.origin,

      refreshAccountsState: 'done',
      refreshAccountsId: null,
      refreshAccountsArgs: {},
      intervalAccounts: null,
      isElectron:false,
      maximized:true,
      interactiveConectorStarted:false,
      forceDownloadLoading: false,
      snackbar: {
        isVisible: false,
        text: '',
        color: 'error',
      },
    };
  },
  metaInfo() {
    return {
      title: this.pageTitle(),
      titleTemplate: null,
    }   
  },
  computed: {
    ...mapGetters([
      'availableTags',
      // 'get_companies', 
      'get_suppliers',
      'get_customers',
      'get_companydbs',
      'is_mobile',
    ]),
    ...mapGetters({
      me: 'me/me',
      userData: 'me/userData',
      useWhiteBrand: 'me/useWhiteBrand',
      hastWhiteBrandColor: 'me/hastWhiteBrandColor',
      got_feature: 'got_feature',
      isWelcomeProcess: 'me/isWelcomeProcess',
      isUpdateProcess: 'me/isUpdateProcess',
      inTutorial: 'me/inTutorial',
      defaultUsername: 'configuration/getDefaultUsername',
      forceRightBar: 'configuration/getForceRightBar',
      creatingMoves: 'accounts/creatingMoves',
      flowLoading: 'documents/flowLoading',
      documentWriting: 'documents/documentWriting',
      currentDoc: 'documents/currentDocument',
      selectedLabel: 'documents/selectedLabel',
      documentIsTrainerMode: 'documents/documentIsTrainerMode',
      currentDocuments: "documents/currentDocuments",
      currentIndex: "documents/currentIndex",
      checkSumOK: 'documents/checkSumOK',
      onAction: 'tutorial/onAction',
      fetching_companydbs:"fetching_companydbs",
      permission: 'permissions/permission',
      show_policy_privacity: 'dialog_contract/show_policy_privacity',
      show_data_treatment: 'dialog_contract/show_data_treatment', 
      show_payment_ok: 'payment_ok_modal/show',
      persistent_payment_ok: 'payment_ok_modal/persistent',
      text_payment_ok: 'payment_ok_modal/text',
      text_center_payment_ok: 'payment_ok_modal/text_center',
      text_title_payment_ok: 'payment_ok_modal/text_title',
      show_title_payment_ok: 'payment_ok_modal/show_title',
      text_confirm_button_payment_ok: 'payment_ok_modal/text_confirm_button',
      show_confirm_button_payment_ok: 'payment_ok_modal/show_confirm_button',
      show_cancel_button_payment_ok: 'payment_ok_modal/show_cancel_button',
      show_question_payment_ok: 'payment_ok_modal/show_question',
      icon_payment_ok: 'payment_ok_modal/icon',
      show_payment_error: 'payment_error_modal/show',
      persistent_payment_error: 'payment_error_modal/persistent',
      text_payment_error: 'payment_error_modal/text',
      text_center_payment_error: 'payment_error_modal/text_center',
      text_title_payment_error: 'payment_error_modal/text_title',
      show_title_payment_error: 'payment_error_modal/show_title',
      text_confirm_button_payment_error: 'payment_error_modal/text_confirm_button',
      show_confirm_button_payment_error: 'payment_error_modal/show_confirm_button',
      show_cancel_button_payment_error: 'payment_error_modal/show_cancel_button',
      show_question_payment_error: 'payment_error_modal/show_question',
      icon_payment_error: 'payment_error_modal/icon',

      showMessageModal: 'messageModal/show',
      textMessageModal: 'messageModal/text',
      textCenterMessageModal: 'messageModal/textCenter',
      textTitleMessageModal: 'messageModal/textTitle',
      showTitleMessageModal: 'messageModal/showTitle',
      textConfirmButtonMessageModal: 'messageModal/textConfirmButton',
      showConfirmButtonMessageModal: 'messageModal/showConfirmButton',
      actionConfirmButtonMessageModal: 'messageModal/actionConfirmButton',
      showCancelButtonMessageModal: 'messageModal/showCancelButton',
      textCancelButtonMessageModal: 'messageModal/textCancelButton',
      actionCancelButtonMessageModal: 'messageModal/actionCancelButton',
      showQuestionMessageModal: 'messageModal/showQuestion',
      textQuestionMessageModal: 'messageModal/textQuestion',
      iconMessageModal: 'messageModal/icon',
      persistentMessageModal: 'messageModal/persistent',
      htmlMessageModal: 'messageModal/isHtml',
    }),
    ...mapState([
      'docStates', 
      'tags', 
      'currentCompany',
      'session_information',
      'oauth_url',
      'oauth_msg',
    ]),
    ...mapFields('notifications', ['notifications']),
    ...mapFields([
      'router_name', 'zones', 'user_items', 'menu', 
      'sellTermsDialog', 'show_accounting_critical_error_msg',/**'show_contract'*/
    ]),
    ...mapFields('dialog_payment', ['show_contract_modal']),
    ...mapFields('documents', ['documentListOptions', 'documentListKind', 'documentIsDebuggerMode']),
    ...mapFields('me',vuexPrefix('user_data_',['can_debug_documents', 'can_see_training_documents'],'userData.', 'doc_num', 'firm_date', 'price')),
    imgSrc() {
      let src = '/logo_blanc.png';
      if (this.is_mobile) {
        src = '/logo_blanc_short.png';
      }
      return src;
    },
    showContractModal() {
      return this.show_contract_modal;
    },
    showNotificationsModal() {
      return this.show_notifications_modal;
    },
    imgWidth() {
      let width = 140;
      if (this.is_mobile) {
        width = 30;
      }
      return width;
    },
    isLoginas() {
      return this.userData && this.userData.hasOwnProperty('username') && this.session_information && this.session_information.hasOwnProperty('username') && (this.session_information.username != this.userData.username);
    },
    showAppBar(){
      let views = this.log_views.concat(this.welcome_views).concat(this.update_views).concat(this.payment_views).concat(this.log_views_old).concat(this.bank_redirect_views);
      return !views.includes(this.router_name);
    },
    showLeftDrawer(){
      // ['login', 'signup', 'welcome', 'update', 'create-contract', 'select-upgrade-create', 'upgrade-contract', 'performing-update', 'create-upgrate-contract', 'payment-error', 'payment-ok']
      let views = this.log_views_old.concat(this.log_views).concat(this.welcome_views).concat(this.update_views).concat(this.payment_views).concat(this.bank_redirect_views);
      return !views.includes(this.router_name);
    },
    showRightBar(){
      return (this.router_name=='document-detail' || this.forceRightBar) && !this.permission.is_readonly && !this.is_mobile;
    },
    showLegalDialog(){
      // ['login','signup','welcome','change_password','connectors','connector-update','connector-create', 'dashboard', 'create-upgrate-contract', 'payment-error', 'payment-ok', 'performing-update']
      let views = this.log_views.concat(this.log_views_old).concat(this.welcome_views).concat(this.payment_views).concat(this.no_cdb_selector_views).concat(this.bank_redirect_views);
      return this.sellTermsDialog && !views.includes(this.router_name);
    },

    showBtnGeneric() {
      let views = this.log_views.concat(this.log_views_old);
      return !views.includes(this.router_name)
    },

    showBurger(){
      return this.showBtnGeneric && this.$vuetify.breakpoint.smAndDown;
    },
    isMini() {
      return this.$vuetify.breakpoint.mdAndUp
    },


    showCDBSelector() {
      // ['login','signup','welcome','change_password','connectors','connector-update','connector-create', 'dashboard', 'performing-update', 'network-drives', 'settings'];
      let views = ['profile'].concat(this.log_views).concat(this.log_views_old).concat(this.welcome_views).concat(this.update_views).concat(this.settings_views).concat(this.no_cdb_selector_views).concat(this.access_registers).concat(this.users_permissions).concat(this.user_configuration);
      return !views.includes(this.router_name);
    },
    isReadonlyCDBSelector() {
      return this.readonly_cdb_selector_views.includes(this.router_name);
    },
    appCustomLogo() {
      if (this.domain.includes('docuxtract.docunecta.com')) {
        return '/docunecta_logo.png'
      } else if (this.domain.includes('gscan.glasof.com')) {
        return '/gscan_logo.png'
      } else if (this.userData.logo) {
        return this.userData.logo
      }
      return null;
    },
    appBg() {
      // Mientras no hayamos podido comprobar si el usuario quiere usar marca blanca o no, mostramos el color blanco.
      let styles = {
        background: '#fff'
      }
      if (!['report-invoice', 'invoice-to-print'].includes(this.router_name)) {
        if (this.domain.includes('docuxtract.docunecta.com')) {
          styles = {background: 'conic-gradient(from 148deg at 18.17% 27.57%, #060647 0deg, #66359B 180.29070854187012deg, #060647 360deg)'}
        } else if (this.domain.includes('gscan.glasof.com')) {
          styles = {background: 'rgb(35, 117, 199)'}
        } else {
          if (this.userData.id) {
            if(this.useWhiteBrand) {
              if (this.hastWhiteBrandColor) {
                styles = { background: this.userData.white_brand_color }              
              } else {
                styles = { background: 'conic-gradient(from 148deg at 18.17% 27.57%, #060647 0deg, #66359B 180.29070854187012deg, #060647 360deg)' }
              }          
            } else {
              styles = { background: 'conic-gradient(from 148deg at 18.17% 27.57%, #060647 0deg, #66359B 180.29070854187012deg, #060647 360deg)' }
            }
            
          }
        }
      }
      return styles
    },
    showForceDownloadLoadPathFiles() {
      if (
        this.got_feature('feature_force_download_load_path') && 
        this.router_name == 'document-list' && this.permission && 
        (this.permission.general.can_admin || this.permission.is_employee) && 
        this.showCDBSelector && !this.is_mobile && this.currentCompany.id && this.currentCompany.has_cloud_load_paths
      ) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    if(this.currentDoc){
      this.check_sum()
    }
    
    this.isElectron = navigator.userAgent == 'InmaticApp';
    if (this.isElectron){
      this.electronCheckInteractiveConnector();
    }
  },
  methods:{
    ...mapActions(['setZones']),
    setSnackbar(color, text) {
      if (text != '') {
        this.snackbar.text = text;
        this.snackbar.isVisible = true;
        this.snackbar.color = color;
      }
      else {
        this.snackbar.text = '';
        this.snackbar.isVisible = false;
      }
    },
    pageTitle() {
        if (window.location.origin.includes('docuxtract.docunecta.com')){
            return 'Docunecta'
        } else if (window.location.origin.includes('gscan.glasof.com')){
            return 'GScan'
        } else {
            return 'Inmatic'
        }
    },
    get_color_loginas() {
      let status_color = '#FF3333'
      if (this.userData.distributor_code) {
        status_color = '#47a73f'
      } else if (this.userData.sender_docs_user_distributor_code) {
        if (this.userData.sender_docs_user_distributor_code == 'sage_50'){
          status_color = '#f1a5fa'
        }
        else{
          status_color = '#10baf5'
        }
        
      } else if (this.userData.status == 'ACTIVE') {
        status_color = '#FFED00'
      }
      return status_color
      
    },
    getCompanies() {
      client.get('companies/').then(response => {
        this.companies = response.data;
      });
    },
    getSuppliers() {
      client.get('suppliers/').then(response => {
        this.suppliers = response.data;
      });
    },
    getCustomers() {
      client.get('customers/').then(response => {
        this.customers = response.data;
      });
    },
    set_suppliers() {
      if (this.currentDoc) {
        this.setSuppliers(this.currentDoc.companydb)
      }
      // this.setAllCurrentsFilters(false);
    },
    set_projects() {
      if (this.currentDoc)
        this.setProjects(this.currentDoc.companydb)
      else if(this.currentCompany)
        this.setProjects(this.currentCompany.id)
    },
    set_activities() {
      if (this.currentDoc)
        this.setActivities(this.currentDoc.companydb)
      else if(this.currentCompany)
        this.setActivities(this.currentCompany.id)
    },
    set_customers() {
      if (this.currentDoc) {
        this.setCustomers(this.currentDoc.companydb)
      }
      
    },
    updateCurrentCompany(new_company) {
      if(new_company){
        this.$router.push({'name': this.$router.currentRoute.name, 'params': { 'companydb_id': new_company.id }});
        this.resetCurrentCompany({new_company: new_company})
      }
    },
    unset_loginas() {  
      let aux = {
        'logged_username': this.session_information.username,
        'loginas_username': this.userData.username,
      };
      this.unsetLoginas(aux).then(()=>{
        this.$router.push({'name': 'dashboard'});
        this.$router.go();
      });
    },
    change_trainer_mode() {
      this.changeTrainerMode().then(()=>{
        this.$router.push({'name': 'document-list'});
        this.$router.go();
      });
    },
    change_debugger_mode() {
      this.changeDebuggerMode().then(()=>{
        this.$router.go();
      });
    },
    startAccounting(){
      this.show_accounting_critical_error_msg = false;
      this.resumeAccounting()
    },
    openEditCompanyDB() {
      let routeData = this.$router.resolve({name: 'connector-update', params: { 'id': this.currentCompany.id }});
      window.open(routeData.href, '_blank');
    },
    electronReload(){
      window.electronAPI.reloadWindow().then(() => {
            console.log("windowReloaded")
      });
    },
    electronMinimize(){
      window.electronAPI.minimize().then(() => {
            console.log("windowMinized")
      });
    },
    electronRestore(){
      window.electronAPI.restore().then(() => {
            console.log("windowRestored")
      });
      this.maximized=false;
    },
    electronMaximize(){
      window.electronAPI.maximize().then(() => {
            console.log("windowMaximized")
      });
      this.maximized=true;
    },
    electronStartInteractiveConnector(){
      const repo = createApiTokenRepository();
      getOrCreateToken(repo).then((result) => {
        let {token} = result;
        window.electronAPI.startInteractiveConnector(token).then(() => {
          console.log("interactiveConnectorStarted")
          this.interactiveConectorStarted=true;
        });
      });
      
    },
    electronStopInteractiveConnector(){
      window.electronAPI.stopInteractiveConnector().then(() => {
            console.log("interactiveConnectorStopped")
            this.interactiveConectorStarted=false;
      });
    },
    electronCheckInteractiveConnector(){
      window.electronAPI.checkInteractiveConnector().then((response) => {
        console.log("interactiveConnectorChecked")
        this.interactiveConectorStarted=response;
      });
    },
    electronClose(){
      window.electronAPI.quit().then(() => {
            console.log("windowClosed")
      });
    },
    ...mapActions([
      'setSuppliers',
      'setCustomers',
      'setCurrentCompany',
      'unsetLoginas',
      'setProjects',
      'setActivities',
      'changeTrainerMode',
      'changeDebuggerMode',
      'refreshData',
      'resetFilters',
      'waitForLoggedIn',
      'resetCurrentCompany',
      'setOauthUrl',
      'resumeAccounting'
    ]),
    ...mapActions({
      // setCurrentHeaders: "documents/setCurrentHeaders",
      getHeader: "documents/getHeader",
      // setAllCurrentsFilters: "documents/setAllCurrentsFilters",
      refreshUserData: "me/refreshUserData",
      setCorrectActions: "documents/setCorrectActions",
      addSimulationAction: "documents/addSimulationAction",
      addAddTagsAction: "documents/addAddTagsAction",
      addTrainingAction: "documents/addTrainingAction",
      addMarkAsErrorAccountConnectorAction: "documents/addMarkAsErrorAccountConnectorAction",
      getContractType:"me/getContractType",
      openContractModal: 'dialog_payment/openContractModal',
      closePaymentErrorModal: 'payment_error_modal/closeModal',
      closePaymentOkModal: 'payment_ok_modal/closeModal',
      refreshAccounts: "connector/refreshAccounts",
      fetchRefreshProgressState: "connector/fetchRefreshProgressState",
    }),
    closeSessionDialog() {
      this.setOauthUrl({url : null})
    },
    connectOauthUser() {
      window.location.href = this.oauth_url
      this.setOauthUrl({url : null})
    },
    refresh_accounts() {
      this.refreshAccountsState = 'pending';
      this.refreshAccounts([this.currentCompany.id]).then((response) => {
        this.refreshAccountsId = response.data.results.ids[0];
        this.intervalAccounts = setInterval(this.fetch_refresh_accounts_state, 2000);
      }).catch(err=>{
        this.refreshProgressState = 'done';
      });
    },
    fetch_refresh_accounts_state() {
      try {
        this.fetchRefreshProgressState(this.refreshAccountsId).then(response => {
          this.refreshAccountsState = response.data.state;
          this.refreshAccountsArgs = response.data.args;
          if (this.refreshAccountsState === "done") {
            clearInterval(this.intervalAccounts);
          } else if (this.refreshAccountsState === "error") {
            clearInterval(this.intervalAccounts);
          }
        });
      } catch (error) {
        console.debug(error);
        clearInterval(this.intervalAccounts);
      }
    },
    async forceDownloadLoadPath() {
      let actual_time = new Date().getTime();
      this.forceDownloadLoading = true;
      let all_ok = true;
      try {
        await new MultipleForceDownloadLoadPathFilesCommand(async_command_dispatcher).run(this.currentCompany.id)
      }
      catch (error) {
        console.error('Error downloading load path files', error)
        all_ok = false;
      }
      let current_time = new Date().getTime();
      let time_diff = current_time - actual_time;
      if (time_diff < 5000) {
        await new Promise(resolve => setTimeout(resolve, 5000 - time_diff));
      }
      this.forceDownloadLoading = false;
      if (!all_ok) {
        this.setSnackbar('error', 'Ha habido un error durante el proceso.');
      }
      else {
        this.setSnackbar('success', 'Proceso de descarga iniciado.');
      }
    }
  },
  watch: {
    onAction() {
      if (this.onAction === "OPEN_ACCOUNT") {
        this.menu = true;
        this.user_items[0].highlighted = true;
      } else {
        this.user_items[0].highlighted = false;
      }
    },
    '$route.name' (to, from) {
      if (to != from) {
        this.router_name = to;
      }
    }
  }
};
</script>

<style>
  .dragBar{
    -webkit-app-region: drag; 
  }
  .white__brand__logo {
    max-height: 100%
  }
  header.appBar{
    background-color: transparent !important;
    box-shadow: none !important; 
  }
  header.appBar .img-top-navigation {
    width: 24px;
    height: 24px;
    max-width: 24px;
  }

  @media print {
    header.appBar{
      display: none;
    }

    nav.drawer {
      display: none
    }

    main.v-main {
      padding: 0px !important;
    }
  }

  .selectedrow{
    background:#eeeeee;
    border-radius:5px;
  }
  .invalid fieldset {
    background-color: #ff7777
  }
  /* .appBar {
    background: linear-gradient(270deg, #9117CC -14.56%, #8263F5 44.51%, #3CF 100%);  
  } */
  .highlighted {
    background-color: #3cf;
  }
  .title-color {
    color:#663399;
  }
  .list:hover {
    background: rgb(102, 51, 153, 0.1) !important;
  }
  .list:hover .list-title {
    color: #663399;
  }
  .drawer {
    z-index: 110;
    max-width: 50%;
  }
  .drawer.main-left-drawer {
    background-color: transparent !important;
  }
  .drawer.main-left-drawer .v-navigation-drawer__border {
    background-color: transparent !important;
  }
  @media screen and (max-width: 960px) {
    .drawer.main-left-drawer {
      background-color: #EDE7F6 !important;
    }
  }
  .drawer.main-left-drawer .v-navigation-drawer__content {
    scrollbar-width: thin;
  }
  .menu {
    z-index: 101;
  }
  .btn_without_caps {
    text-transform: unset !important;
  }
  .v-icon {
    transition: none !important;
  }
  .v-icon.v-icon::after {
      transition: none !important;
  }  

  .container-full-bg-gray {
    height: 100%;
    background-color: #ededed;
    border-top-left-radius: 15px;
    position:absolute;
    overflow-y:auto;
  }

  .container-full-bg-transaparent {
    height: 100%;
    position:absolute;
    overflow-y:auto;
    padding: 0px;
    scrollbar-width: none;
  }

  @font-face {
    font-family: Ubuntu;
    font-weight: 300;
    src: url('/Ubuntu-Light.ttf');
  }
  @font-face { font-family: Ubuntu; src: url('/Ubuntu-Regular.ttf'); } 
  @font-face { font-family: Ubuntu; font-weight: bold; src: url('/Ubuntu-Bold.ttf');}

</style>